import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

const ACCESS = "otms_access";
const REFRESH = "otms_refresh";

export const tokens = {
  set(access, refresh) {
    localStorage.setItem(ACCESS, access);
    if (refresh) localStorage.setItem(REFRESH, refresh);
  },
  clear() {
    localStorage.removeItem(ACCESS);
    localStorage.removeItem(REFRESH);
  },
  access: () => localStorage.getItem(ACCESS),
  refresh: () => localStorage.getItem(REFRESH),
};

api.interceptors.request.use((cfg) => {
  const t = tokens.access();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const isAuth = original?.url?.startsWith("/auth/");
    if (error.response?.status === 401 && !original._retry && !isAuth && tokens.refresh()) {
      original._retry = true;
      try {
        refreshing = refreshing || axios.post(`${API}/auth/refresh`, { refresh_token: tokens.refresh() });
        const { data } = await refreshing;
        tokens.set(data.access_token);
        return api(original);
      } catch (e) {
        tokens.clear();
        window.location.href = "/login";
      } finally {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""}: ${x.msg}`).join("; ");
  if (d.message) return `${d.message}${d.problems?.length ? ": " + d.problems.join("; ") : ""}`;
  return String(d);
}

export async function downloadFile(path, params, fallbackName) {
  const res = await api.get(path, { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
  const name = m ? decodeURIComponent(m[1].replace(/"/g, "")) : fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
  return res.headers["x-integrity-verified"];
}

export const newIdempotencyKey = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
